export class ArgumentNullException extends Error {}
